import axios from '@/plugins/axiosInstance'
import { suggestions } from '@/networking/urlManager'

export const deleteSuggestion = async (id, params = {}) => {
  try {
    const response = await axios.post(suggestions.delete.replace(':id', id), { params })
    return response.data
  } catch (error) {
    console.error(`Error deleting suggestion with id ${id}:`, error)
    throw error
  }
}
